import {DELETE_CATEGORY_WITH_DRAFTS}  from '../constants/drafts-constants';
import {INIT_SETTINGS, START_AJAX_REQUEST, END_AJAX_REQUEST} from '../constants/settings-constants';

const initState = {
    count: 20,
    link: undefined,
    name_variant: undefined,
    fetching: false
};

export default function settings(state=initState, action) {
    switch(action.type) {
        case INIT_SETTINGS:
            return { ...state,...action.data };
        case DELETE_CATEGORY_WITH_DRAFTS:
            return {
            ...state,
                count: state.count - action.count
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_app/drafts/reducers/settings_reducer.js